export enum PersonalIdTypeEnum {
    DriverLicense = 1,
    Passport = 2,
    TinCard = 3,
    HealthId = 4,
    OfwId = 5,
    VotersId = 6,
    UmidId = 7,
    NationalId = 8,
    PrcId = 9
}
